var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.598,
    height: 25,
    viewBox: "0 0 25.598 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Icons",
    "data-name": "Menu Icons",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 25,
    height: 25,
    transform: "translate(0.248)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4317",
    "data-name": "Group 4317",
    transform: "translate(-8089.267 14001.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4228",
    "data-name": "Group 4228",
    transform: "translate(8089.516 -13997.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5761",
    "data-name": "Path 5761",
    d: "M451.286,513.465a5.425,5.425,0,1,1,5.425-5.425A5.426,5.426,0,0,1,451.286,513.465Zm0-9.921a4.5,4.5,0,1,0,4.5,4.5A4.5,4.5,0,0,0,451.286,503.544Z",
    transform: "translate(-443.534 -502.614)",
    fill: "#5b788f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5761_-_Outline",
    "data-name": "Path 5761 - Outline",
    d: "M451.287,513.715h0a5.675,5.675,0,1,1,5.675-5.675A5.682,5.682,0,0,1,451.286,513.715Zm0-10.851a5.175,5.175,0,1,0,5.175,5.175A5.181,5.181,0,0,0,451.286,502.864Zm0,9.921a4.745,4.745,0,0,1,0-9.491h0a4.745,4.745,0,0,1,0,9.491Zm0-8.991a4.245,4.245,0,1,0,4.246,4.245,4.25,4.25,0,0,0-4.246-4.245Z",
    transform: "translate(-443.534 -502.614)",
    fill: "#5b788f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762",
    "data-name": "Path 5762",
    d: "M442.955,525.227a.48.48,0,0,1-.245-.072.468.468,0,0,1-.148-.642l1.646-2.635a2.765,2.765,0,0,1,2.356-1.3h7.4a2.79,2.79,0,0,1,2.31,1.24l1.792,2.691a.465.465,0,0,1-.754.545l-.018-.027-1.795-2.691a1.861,1.861,0,0,0-1.55-.822h-7.385a1.832,1.832,0,0,0-1.55.865l-1.646,2.635A.469.469,0,0,1,442.955,525.227Z",
    transform: "translate(-442.492 -508.173)",
    fill: "#5b788f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762_-_Outline",
    "data-name": "Path 5762 - Outline",
    d: "M457.692,525.5a.718.718,0,0,1-.58-.3l0,0-.023-.034-1.792-2.687a1.609,1.609,0,0,0-1.337-.711h-7.391a1.573,1.573,0,0,0-1.338.747l-1.646,2.635a.715.715,0,0,1-.635.331.732.732,0,0,1-.369-.109.72.72,0,0,1-.23-.986L444,521.747a3,3,0,0,1,2.558-1.42h7.413a3.036,3.036,0,0,1,2.518,1.351l1.79,2.688a.715.715,0,0,1-.582,1.129Zm-.174-.588a.215.215,0,0,0,.348-.253l-.005-.008-1.792-2.691a2.536,2.536,0,0,0-2.1-1.129h-7.412a2.5,2.5,0,0,0-2.134,1.185l-1.646,2.635a.218.218,0,0,0,.07.3.229.229,0,0,0,.116.033h.017a.218.218,0,0,0,.184-.1l1.644-2.632a2.071,2.071,0,0,1,1.761-.983h7.391a2.108,2.108,0,0,1,1.752.932l1.8,2.7Z",
    transform: "translate(-442.492 -508.173)",
    fill: "#5b788f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4230",
    "data-name": "Group 4230",
    transform: "translate(8103.303 -13995.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5761-2",
    "data-name": "Path 5761",
    d: "M449.744,510.38a3.883,3.883,0,1,1,3.883-3.883A3.883,3.883,0,0,1,449.744,510.38Zm0-7.1a3.217,3.217,0,1,0,3.217,3.217A3.218,3.218,0,0,0,449.744,503.28Z",
    transform: "translate(-444.196 -503.198)",
    fill: "#5b788f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5761_-_Outline-2",
    "data-name": "Path 5761 - Outline",
    d: "M449.744,510.73h0a4.233,4.233,0,1,1,4.233-4.233A4.238,4.238,0,0,1,449.744,510.73Zm0-7.1a2.867,2.867,0,1,0,2.868,2.867,2.87,2.87,0,0,0-2.868-2.867Z",
    transform: "translate(-444.196 -503.198)",
    fill: "#5b788f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762-2",
    "data-name": "Path 5762",
    d: "M442.823,523.905a.345.345,0,0,1-.175-.051.335.335,0,0,1-.106-.459l1.178-1.886a1.979,1.979,0,0,1,1.686-.932h5.3a2,2,0,0,1,1.653.888l1.282,1.926a.333.333,0,0,1-.54.39l-.013-.019-1.284-1.926a1.332,1.332,0,0,0-1.109-.588h-5.285a1.311,1.311,0,0,0-1.109.619l-1.178,1.886A.335.335,0,0,1,442.823,523.905Z",
    transform: "translate(-442.492 -511.699)",
    fill: "#5b788f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762_-_Outline-2",
    "data-name": "Path 5762 - Outline",
    d: "M453.371,524.268a.685.685,0,0,1-.554-.282l-.024-.035-1.281-1.921a.98.98,0,0,0-.814-.432h-5.289a.956.956,0,0,0-.812.454l-1.182,1.891a.685.685,0,0,1-.6.313.7.7,0,0,1-.348-.1.687.687,0,0,1-.22-.941l1.179-1.887a2.315,2.315,0,0,1,1.976-1.1H450.7a2.344,2.344,0,0,1,1.944,1.043l1.28,1.922a.683.683,0,0,1-.558,1.076Z",
    transform: "translate(-442.492 -511.699)",
    fill: "#5b788f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyStaff);
export default __webpack_public_path__ + "static/media/icon_my_staff.ed29a13ad3b740343d4827fd983466ed.svg";
export { ForwardRef as ReactComponent };